"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var pickers_1 = require("@material-ui/pickers");
var react_1 = __importDefault(require("react"));
var constants_1 = __importDefault(require("../../../config/constants"));
var DateInput = function (_a) {
    var disableFuture = _a.disableFuture, theme = _a.theme, pickerProps = __rest(_a, ["disableFuture", "theme"]);
    var classes = styles(theme)();
    return (react_1.default.createElement(pickers_1.DatePicker, __assign({ style: { margin: '16px 8px' }, className: classes.root, DialogProps: { className: classes.datePicker }, disableToolbar: true, disableFuture: disableFuture, inputVariant: constants_1.default.FIELDS_VARIANT }, pickerProps)));
};
var styles = function (theme) {
    return (0, core_1.makeStyles)({
        root: {
            '& .MuiOutlinedInput-input': {
                border: '1px solid gray',
                borderRadius: '0',
                backgroundColor: theme.palette.background.paper,
                '&:focus': {
                    boxShadow: theme.shadows[3],
                    borderColor: theme.palette.grey[700]
                }
            }
        },
        datePicker: {
            '& .MuiPickersDay-daySelected': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.background.paper,
                '&:hover': {
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.primary.main
                }
            },
            '& .MuiButtonBase-root:hover': {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.primary.main
            }
        }
    });
};
exports.default = DateInput;
//# sourceMappingURL=DateInput.js.map